import { useState, useEffect } from "react";
import { useLocation, useOutletContext } from "react-router";

import ModernBanner from "../shopping/component/themes/modern/banner";
import CuteBanner from "../shopping/component/themes/cute/banner";
import SimpleBanner from "../shopping/component/themes/simple/banner";
import Help from "./component/help";
import ChicBanner from "../shopping/component/themes/chic/banner";
import MediaViewer from "../../../common/mediaViewer";
// import DefaultBanner from "../shopping/component/themes/default/banner";
import TabMenu from "../common/tabMenu";
import Notice from "./component/notice";

import { Container } from "../common/styled";
import { SectionContainer } from "./component/styled";

const ShoppingNotice = () => {
  const { theme, menus } = useOutletContext();
  const [active, setActive] = useState(0);
  const [isDetail, setIsDetail] = useState(false);
  const [images, setImages] = useState([]);
  const location = useLocation();

  useEffect(() => {
    const tabIndex = location?.state?.tabIndex;
    if (tabIndex) {
      setActive(tabIndex);
    }
  }, []);

  const menu = [
    "공지사항",
    // "자주 묻는 질문",
    "1:1 문의",
  ];

  const components = [<Notice />, <Help setImages={setImages} setIsDetail={setIsDetail} />];
  const banners = {
    0: <ModernBanner />,
    1: <ChicBanner />,
    2: <ModernBanner />,
    3: <CuteBanner />,
    4: <SimpleBanner />,
  };

  const renderComponent = () => {
    const Banner = banners[theme];

    return (
      <>
        {Banner}
        <h3 className="max">
          <span>{menu[active]}</span>
        </h3>
        <TabMenu setActive={setActive} active={active} menus={menu} />
        <SectionContainer className={`theme-${theme}`}>{components[active]}</SectionContainer>
      </>
    );
  };

  return (
    <Container className={`theme-${theme}`}>
      {renderComponent()}
      {isDetail && <MediaViewer files={images} setIsOpen={setIsDetail} />}
    </Container>
  );
};

export default ShoppingNotice;
